var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckeredPatterni = function SvgCheckeredPatterni(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'currentColor',
    opacity: 0.3,
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16V8h8v8zM0 8V0h8v8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16V8h8v8zm8-8V0h8v8z",
    opacity: 0.6
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckeredPatterni);
export default ForwardRef;